import {AppAccessStatus} from "../../../shared/enums/appAccessStatus";
import Tag from "../../atoms/tag/tag";
import {useTranslation} from "react-i18next";
import React from "react";
import Icon from "../../atoms/common/icon/icon";
import {IconSource} from "../../../shared/enums/iconSource";
import "./appAccessStatusTab.sass";

export interface IAppAccessStatusTabProps {
  appAccessStatus: AppAccessStatus | undefined;
}

const AppAccessStatusTab: React.FC<IAppAccessStatusTabProps> = ({
  appAccessStatus
}) => {
  const {t} = useTranslation(["residentadmin"]);

  switch (appAccessStatus) {
    case AppAccessStatus.Access:
      return (
        <Tag
          text={t("residentadmin:labels.accountStatusAccess")}
          type="system"
        />
      );
    case AppAccessStatus.Active:
      return (
        <Tag
          text={t("residentadmin:labels.accountStatusActive")}
          type="success"
        />
      );
    case AppAccessStatus.RequiresAction:
      return (
        <span className="tag warning-tag">
          <Icon source={IconSource.error} />
          <span className="action-error-label">
            {t("residentadmin:labels.accountStatusRequiresAction")}
          </span>
        </span>
      );
    default:
      // Use inactive as the default
      return (
        <Tag
          text={t("residentadmin:labels.accountStatusInactive")}
          type="neutral"
        />
      );
  }
};

export default AppAccessStatusTab;
